<header>
  <div class="header-left">
    <button *ngIf="stepper?.selectedIndex && !hideBackButton" type="button" id="prev-button" (click)="onPrevious()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M15 8H1"
          attr.stroke="{{ data?.brandColor }}"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M8 15L1 8L8 1"
          attr.stroke="{{ data?.brandColor }}"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>
    <span class="title">{{ title }}</span>
  </div>
  <button id="close-button" (click)="onClose()" [ngStyle]="{ visibility: hideCloseButton ? 'hidden' : 'visible' }">
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
      <path d="M7 7L1 1M7 1L1 7" stroke="#7A89AD" stroke-width="2" stroke-linecap="round" />
    </svg>
  </button>
</header>
<main>
  <mat-stepper *ngIf="isAllowedToEdit" #stepper id="edit-delivery-stepper" (selectionChange)="onStepChange($event)">
    <mat-step *ngFor="let step of steps">
      <div>
        <ng-template *ngComponentOutlet="step.component; inputs: step.inputs"></ng-template>
      </div>
    </mat-step>
  </mat-stepper>

  <ng-container *ngIf="!isAllowedToEdit">
    <common-contact-us-menu></common-contact-us-menu>
  </ng-container>
</main>
